import { apiClient } from '@borradh-workspace/api-client';
import { packageWithItemsSchema } from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from '@/lib/query-keys';

import type { PackageWithItems } from '../types';

// `GET /packages` is a bare array; contracts exports only the element schema.
const listPackagesResponseSchema = z.array(packageWithItemsSchema);

export const listPackagesQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.packages.list(),
    queryFn: () =>
      apiClient.get<PackageWithItems[]>('packages', {
        schema: listPackagesResponseSchema,
      }),
    staleTime: 5 * 60 * 1000,
  });

export const useListPackages = () => {
  const query = useQuery(listPackagesQueryOptions());
  return {
    packages: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
